import type { ReactNode } from "react";
import { PublicFooter } from "@/components/public-footer";
import { PublicHeader } from "@/components/public-header";
import { cn } from "@/lib/utils";

interface PublicLayoutProps {
	children: ReactNode;
	className?: string;
}

export function PublicLayout({ children, className }: PublicLayoutProps) {
	return (
		<div className="min-h-screen bg-background">
			<PublicHeader />
			<main className={cn("flex flex-1 flex-col", className)}>{children}</main>
			<PublicFooter />
		</div>
	);
}
